import { render, staticRenderFns } from "./AssetAssignModal.vue?vue&type=template&id=0c1bf8c2"
import script from "./AssetAssignModal.vue?vue&type=script&lang=js"
export * from "./AssetAssignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports